import { gql } from '@apollo/client';
const UPDATE_PRODUCT_CATEGORY = gql `
  mutation UpdateProductCategory(
    $productCategoryId: ID!
    $typeLabelPL: String!
    $typeLabelEN: String!
    $filtersAvailable: Boolean!
  ) {
    updateProductCategory(
      productCategoryId: $productCategoryId
      typeLabelPL: $typeLabelPL
      typeLabelEN: $typeLabelEN
      filtersAvailable: $filtersAvailable
    ) {
      productCategory {
        id
        type
        typeLabelPL
        typeLabelEN
        typeIcon
        displayOrder
        filtersAvailable
        productsCount
      }
    }
  }
`;
export default UPDATE_PRODUCT_CATEGORY;
